export default __webpack_public_path__ + "static/star-logo-color-c257f5aba5aa72dfc91c41156d4f982f.png";